export default "/images/37ebcd1f01bd0a1ba4094f84fd0064dd.avif";